export default __webpack_public_path__ + "static/media/HistoricRobin.e3db0ccd.png";